import { useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Entrees from "./pages/Entrees";
import Main from "./pages/Main";
import Dessert from "./pages/Dessert";
import Home from "./pages/Home";
import Reservation from "./pages/Reservation";
import HomeNavbar from "./components/HomeNavbar";
import AboutUs from "./pages/AboutUs";
import CancelReservation from "./pages/CancelReservation";
import Drinks from "./pages/Drinks";
import Kids from "./pages/Kids";
import EntreesDinner from "./pages/EntreesDinner";
import NavbarDinner from "./components/NavbarDinner";
import MainDinner from "./pages/MainDinner";
import DessertDinner from "./pages/DessertDinner";
import DrinksDinner from "./pages/DrinksDinner";
import Sharing from "./pages/Sharing";

export default function App() {
  const [language, setLanguage] = useState("fr");
  const location = useLocation();

  // Vérifie si la route actuelle est la page de confirmation de réservation
  const isReservationConfirmation = location.pathname.startsWith("/ReservationConfirmation");

  return (
    <>
      {/* Afficher HomeNavbar sur toutes les pages sauf ReservationConfirmation */}
      {!isReservationConfirmation && (
        <HomeNavbar language={language} setLanguage={setLanguage} />
      )}

      {/* Afficher Navbar seulement sur les pages de menu */}
      {['/Entrees', '/main',"/Sharing", ,'/Dessert','/Drinks','/Kids'].includes(location.pathname) && (
        <Navbar language={language} />
      )}

        {/* Afficher Navbar seulement sur les pages de menu */}
      {['/MainDinner','/EntreesDinner','/DessertDinner' ,'/DrinksDinner'].includes(location.pathname) && (
        <NavbarDinner language={language} />
      )}

      <Routes>
        <Route path="/" element={<Home language={language} setLanguage={setLanguage} />} />
        <Route path="/Reservation" element={<Reservation language={language} />} />
        <Route path="/about-us" element={<AboutUs language={language} setLanguage={setLanguage} />} />
        <Route path="/Entrees" element={<Entrees language={language} />} />
        <Route path="/main" element={<Main language={language} />} />
        <Route path="/Dessert" element={<Dessert language={language} />} />
        <Route path="/Drinks" element={<Drinks language={language} />} />
        <Route path="/Kids" element={<Kids language={language} />} />
        <Route path="/EntreesDinner" element={<EntreesDinner language={language} />} />
        <Route path="/MainDinner" element={<MainDinner language={language} />} />
        <Route path="/DessertDinner" element={<DessertDinner language={language} />} />
        <Route path="/DrinksDinner" element={<DrinksDinner language={language} />} />
        <Route path="/CancelReservation" element={<CancelReservation language={language}/>} />
        <Route path="/Sharing" element={<Sharing language={language}/>} />
        
        
      </Routes>
    </>
  );
}